module.exports = __webpack_public_path__ + "static/media/Lightroom.8ff4e409.svg";